import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ArrayList, Parser } from 'maf-web';
import { AppService } from '../../app.service';
import { ConsLojaAPP, ConsVendedorAPP } from '../../vo/sitevo.vo';

@Component({
  selector: 'lojas-vendedores',
  templateUrl: './vendedores.component.html',
  styleUrls: ['../../app.css', '../lojas.css']
})
export class VendedoresComponent implements OnInit {

  vendedores: ArrayList<ConsVendedorAPP>;
  loja: ConsLojaAPP;

  constructor(
    private app: AppService,
    private router: Router
  ) { }

  ngOnInit(): void {
    if (this.app.lojas == null || this.app.lojaSelecionada === 0) {
      this.router.navigate(['/inicio']);
    }
    this.loja = this.app.lojas.listLoja.find(i => i.codEmpresa === this.app.lojaSelecionada);
    this.vendedores = this.app.lojas.listVendedor.filter(i => i.listEmpresa.find(e => e === this.app.lojaSelecionada) && i.whatsApp > 0);
  }

  formatarTelefone(vendedor: ConsVendedorAPP): string {
    return Parser.formataFone(vendedor.whatsApp + '');
  }

  abrirWhatsApp(vendedor: ConsVendedorAPP) {
    const vendedorNome = vendedor.nome.split(' ').filter(i => i.length > 0);
    const linkApi: string = this.app.isMobile ? 'api' : 'web';
    const a = document.createElement('a');
    a.target = '_blank';
    a.href = `https://${linkApi}.whatsapp.com/send?phone=55${vendedor.whatsApp}&text=${encodeURI(`Olá ${vendedorNome[0]}, tudo bem?`)}`;
    a.click();
  }

  voltar() {
    this.router.navigate(['/lojas']);
  }

  mapa(loja: ConsLojaAPP) {
    const endereco = loja.logradouro.replace(',', '') + ' , ' + loja.numero + ' , ' + loja.bairro + ' , ' + loja.cidade;
    const queryMaps = endereco.split(' ').filter(i => i.length > 0).join('+');
    const win = window.open('https://www.google.com/maps/search/?api=1&query=' + encodeURI(queryMaps), '_blank');
    win.focus();
  }

}
